import {Layer} from "features/apartmentViewer/ApartmentViewer/layers/Layer";
import {Scene, WebGLRenderer} from "three";
import {CanvasService} from "features/apartmentViewer/ApartmentViewer/services/CanvasService";
import {CameraHandler} from "features/apartmentViewer/ApartmentViewer/services/CameraHandler";

export class EmptyLayer extends Layer {
    private readonly scene: Scene;

    constructor(
        canvasService: CanvasService,
        private renderer: WebGLRenderer,
        private cameraHandler: CameraHandler
    ) {
        super(canvasService);
        this.scene = new Scene();

    }

    update() {
        if(this.scene.children.length > 0) {
            this.renderer.setClearColor(0, 0);
            this.renderer.setRenderTarget(this.renderTexture);
            this.renderer.render(this.scene, this.cameraHandler.camera);
            this.renderer.setRenderTarget(null);
        }
    }
}
